import * as actionTypes from "Consts/actionsTypes";

const defaultState = {
  show: false,
  loading: false,
  url: "",
  text: "",
};

export const searchField = (state = defaultState, action) => {
  switch (action.type) {
    case actionTypes.SEARCH__LOADING:
      state = {
        ...state,
        loading: action.payload,
      };
      break;
    case actionTypes.SEARCH_FIELD__TOGGLE:
      state = {
        ...state,
        show: action.payload.show,
      };
      break;
    case actionTypes.SEARCH_FIELD__SETVALUES:
      state = {
        ...state,
        url: action.payload.url,
        text: action.payload.text,
      };
      break;
  }
  return state;
};
